import { useNavigate } from "react-router-dom";

import ConfirmationQuestion from "../../../components/Questions/ConfirmationQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { questionContent } from "../questions";

const ChronicIllness: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer: ConfirmationAnswer) => {
    setAnswers({
      ...answers,
      chronicIllness: answer,
      ...(answer !== ConfirmationAnswer.Yes
        ? {
            chronicIllnessDetail: undefined,
          }
        : {}),
    });
  };

  const onContinue = () => {
    if (answers.chronicIllness === ConfirmationAnswer.Yes) {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.ChronicIllnessDetail}`);
    } else {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.Financial}`);
    }
  };

  return (
    <ConfirmationQuestion
      onChange={onChange}
      value={answers.chronicIllness}
      onContinue={onContinue}
      step={questionContent.chronicIllness.step}
      title={questionContent.chronicIllness.title}
      subTitle={questionContent.chronicIllness.subTitle}
      whyWeWantTexts={questionContent.chronicIllness.whyWeWantTextsCustomer}
    />
  );
};

export default ChronicIllness;
